import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // document.addEventListener("click", this.toggleAccountForm.bind(this), false);
  }
}
